import React, { useState } from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import HintDialog from './HintDialog';
import { useSelector } from 'react-redux';
import { HintMessages } from '../../Enums';
import { areHintMessagesDisabled } from '../Reducers/HintMessages/Selectors';

const styles = (theme) => ({
  button: {
    pointerEvents: 'all',
    [theme.breakpoints.down('xs')]: {
      height: 56,
    },
  },
  buttonXs: {
    pointerEvents: 'all',
    height: 56,
    textTransform: 'none',
  },
  initialCallWrapper: {
    position: 'absolute',
    right: '110%',
    minWidth: 253,
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    color: theme.palette.secondary.dark,
    '& div': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      right: 0,
      top: 50,
      display: 'block',
      textAlign: 'center',

      width: '100%',
      '& div': {
        marginBottom: 15,
      },
    },
  },
});

export const EditDesignButton = withWidth({ initialWidth: 'lg' })(
  withStyles(styles, { name: 'EditDesignButton' })(({ openDesignArea, classes, buttonXS }) => {
    const [anchorRef, setAnchorRef] = useState(null);
    const activeHintMessage = useSelector((state) => state.hintMessages.activeHintMessage);

    return (
      <>
        {buttonXS ? (
          <React.Fragment>
            <Button
              onClick={openDesignArea}
              size="large"
              fullWidth
              variant="text"
              className={clsx(classes.buttonXs, customClassName('open-editor-button'))}
              ref={setAnchorRef}
            >
              <Icon style={{ paddingRight: 5 }}>edit</Icon>
              {t('designAreaControlBox.editDesign')}
            </Button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <MainButton
              onClick={openDesignArea}
              size="large"
              variant="contained"
              className={clsx(classes.button, customClassName('open-editor-button'))}
              fullWidth
              ref={setAnchorRef}
            >
              {t('designAreaControlBox.editDesign')}
            </MainButton>
          </React.Fragment>
        )}
        {/* LAN-32 Adding Hint Dialog */}
        {!areHintMessagesDisabled() && activeHintMessage === HintMessages.EditDesignButton && (
          <HintDialog
            offsetDirection={'left'}
            anchorRef={anchorRef}
            offset={10}
            perpendicularOffset={35}
            title={t('hintMessages.hint1.title')}
            content={t('hintMessages.hint1.content')}
          />
        )}
      </>
    );
  })
);

export default EditDesignButton;
